"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognitionTimesRequest = void 0;
var RecognitionTimesRequest = /** @class */ (function () {
    function RecognitionTimesRequest() {
    }
    return RecognitionTimesRequest;
}());
exports.RecognitionTimesRequest = RecognitionTimesRequest;
;
//# sourceMappingURL=recognitionTimes.request.js.map